import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL, THUMBNAIL_URL } from './constants';

/**
 * Meta + Open Graph + Twitter + canonical par page SPA.
 */
export function SeoHelmet({ title, description, path, keywords, ogType = 'website', jsonLd }) {
  const urlPath = path.startsWith('/') ? path : `/${path}`;
  const pageUrl = `${SITE_URL}${urlPath}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <link rel="canonical" href={pageUrl} />

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={THUMBNAIL_URL} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="Patrick Noah" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={THUMBNAIL_URL} />

      <meta name="robots" content="index, follow" />

      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
}
